// Set Cesium base URL for static assets
(window as any).CESIUM_BASE_URL = '/cesiumStatic';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { ThemeProvider } from './common/contexts/ThemeContext';
import { useThemeMode } from './common/contexts/ThemeContext';
import { createAppTheme } from './common/theme';

// Component to provide MUI theme based on theme mode
const ThemedApp: React.FC = () => {
  const { mode } = useThemeMode();
  const theme = createAppTheme(mode);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MuiThemeProvider>
  );
};

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  </React.StrictMode>
); 